import Skeleton from '@/components/atoms/Skeleton/Skeleton';
import { cn } from '@/utils/cn';

const LivescoreSeasonTableSkeleton = () => {
  // Generate skeleton rows (8 teams is typical for many league tables)
  const skeletonRows = Array.from({ length: 8 }, (_, index) => (
    <tr key={index} className="text-[12px] group">
      {/* Position circle */}
      <td
        className={cn(
          'pl-4 dark:bg-black-400 bg-white_theme-50 py-2.5 w-12 flex justify-center',
          index === 7 && 'rounded-bl-3xl',
        )}
      >
        <Skeleton className="rounded-full w-[21px] h-[21px]" />
      </td>

      {/* Team name and logo */}
      <td className="w-auto pl-4">
        <div className="flex items-center gap-2 group-odd:dark:bg-black-400 group-odd:bg-white_theme-50 py-2.5">
          <Skeleton className="w-4 h-4 rounded-full" />
          <Skeleton className="h-3 w-32" />
        </div>
      </td>

      {/* Stats columns - default view (M, B, P) */}
      <td className="text-center group-odd:dark:bg-black-400 group-odd:bg-white_theme-50 py-2.5 w-8">
        <Skeleton className="h-3 w-4 mx-auto" />
      </td>
      <td className="text-center group-odd:dark:bg-black-400 group-odd:bg-white_theme-50 py-2.5 w-16">
        <Skeleton className="h-3 w-8 mx-auto" />
      </td>
      <td
        className={cn(
          'text-center group-odd:dark:bg-black-400 group-odd:bg-white_theme-50 py-2.5 w-14 pr-6',
          index === 7 && 'rounded-br-3xl',
        )}
      >
        <Skeleton className="h-3 w-6 mx-auto" />
      </td>
    </tr>
  ));

  return (
    <>
      <div className="w-full border dark:border-border-400 border-gray-250 rounded-t-3xl rounded-b-xl">
        {/* Type picker section skeleton */}
        <div className="py-2 px-3">
          <div className="flex items-center gap-2 px-4 py-2">
            <Skeleton className="h-8 w-full !rounded-full" />
            <div className="w-full" />
            <div className="w-full" />
            <div className="w-full" />
          </div>
        </div>

        {/* Table skeleton */}
        <div className="mt-2">
          <table className="w-full">
            {/* Table header */}
            <thead className="border-b dark:border-border-400 border-gray-250">
              <tr className="text-xxs text-gray-400">
                <th className="text-center py-3 w-12 pl-4">
                  <Skeleton className="h-3 w-3 mx-auto" />
                </th>
                <th className="text-left py-3 w-auto pl-4">
                  <Skeleton className="h-3 w-16" />
                </th>
                <th className="text-center py-3 w-8">
                  <Skeleton className="h-3 w-3 mx-auto" />
                </th>
                <th className="text-center py-3 w-16">
                  <Skeleton className="h-3 w-3 mx-auto" />
                </th>
                <th className="text-center py-3 w-14 pr-6">
                  <Skeleton className="h-3 w-3 mx-auto" />
                </th>
              </tr>
            </thead>

            {/* Table body with skeleton rows */}
            <tbody>{skeletonRows}</tbody>
          </table>
        </div>
      </div>

      {/* Outcome legends skeleton */}
      <div className="space-y-2 mt-6">
        {/* Promotion outcomes */}
        {Array.from({ length: 2 }, (_, index) => (
          <div key={`promotion-${index}`} className="flex items-center gap-2">
            <Skeleton className="w-3.5 h-3.5 rounded-full" />
            <Skeleton className="h-3 w-24" />
          </div>
        ))}
      </div>

      <div className="space-y-2 mt-2">
        {/* Relegation outcomes */}
        {Array.from({ length: 1 }, (_, index) => (
          <div key={`relegation-${index}`} className="flex items-center gap-2">
            <Skeleton className="w-3.5 h-3.5 rounded-full" />
            <Skeleton className="h-3 w-20" />
          </div>
        ))}
      </div>
    </>
  );
};

export default LivescoreSeasonTableSkeleton;
